export interface SupplierProductDetails {
  id: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  productId: string;
  productKey: string;
  productDescription: string;
  productType: string;
  default: boolean;
  defaultYesNo: string;
  partNo: string;
  currencyCode: string;
  currencySymbol: string;
  stdPrice: number;
  stdCutPrice: number;
  minimumOrderQty: number;
}
